<template>
  <div id="settings-wrapper">
    <v-card
      id="settings"
      class="py-2 px-2"
      color="rgba(0, 0, 0, .3)"
      dark
      flat
      link
      min-width="100"
      style="position: fixed; top: -12px; right: -65px; border-radius: 8px;"
    >
      <v-icon>
        mdi-cog
      </v-icon>
    </v-card>

    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      activator="#settings"
      bottom
      content-class="v-settings"
      left
      nudge-left="8"
      offset-x
      origin="top right"
      transition="scale-transition"
    >
      <v-card
        class="text-center mb-0"
        width="300"
      >
        <v-card-text>
          <strong class="mb-2 d-inline-block">{{ $tc("setting", 2) }}</strong>

          <v-row
            align="center"
            no-gutters
          >
            <v-col cols="auto">
              {{ $tc("darkmode", 1) }}
            </v-col>

            <v-spacer />

            <v-col cols="auto">
              <v-switch
                v-model="dark"
                class="ma-0 pa-0"
                color="primary"
                hide-details
              />
            </v-col>
          </v-row>

          <v-divider class="my-4 primary" />

          <strong class="mb-2 d-inline-block">{{ $tc("menu", 1) }}</strong>

          <v-row
            align="center"
            no-gutters
          >
            <v-col cols="auto">
              {{ $tc("mini", 1) }}
            </v-col>

            <v-spacer />

            <v-col cols="auto">
              <v-switch
                v-model="mini"
                class="ma-0 pa-0"
                color="primary"
                hide-details
              />
            </v-col>
          </v-row>

          <v-divider class="my-4 grey" />

          <v-item-group
            v-model="image"
            class="d-flex justify-space-between mb-3"
          >
            <v-item
              v-for="image in images"
              :key="image"
              :value="image"
              class="mx-1"
            >
              <template #default="{ active, toggle }">
                <v-sheet
                  :class="active && 'v-settings__item--active'"
                  class="d-inline-block v-settings__item"
                  @click="toggle"
                >
                  <v-img
                    :src="require(`@/my/assets/backgrounds/` + image)"
                    height="100"
                    width="50"
                  />
                </v-sheet>
              </template>
            </v-item>
          </v-item-group>

          <v-divider class="my-4 primary" />

          <strong class="mb-2 d-inline-block">{{ $tc("language", 1) }}</strong>

          <div>
            <span
              v-for="(l, i) in $store.state.locales"
              :key="'L'+i"
            >
              <span v-if="i > 0"> | </span>
              <a
                class="grey--text text--lighten-1"
                @click="$store.commit('SET_LOCALE', l.value); $i18n.locale = l.value; $vuetify.lang.current = l.value"
              >
                <span :class="{ 'primary--text': $i18n.locale === l.value }">{{ l.text }}</span>
              </a>
            </span>
          </div>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
  // Mixins
  import Proxyable from 'vuetify/lib/mixins/proxyable'
  import { mapMutations, mapState } from 'vuex'

  export default {
    name: 'DashboardCoreSettings',

    mixins: [Proxyable],

    data: () => ({
      color: '#E91E63',
      colors: [
        '#9C27b0',
        '#00CAE3',
        '#4CAF50',
        '#ff9800',
        '#E91E63',
        '#FF5252',
      ],
      image: 'records-side.png',
      images: [
        'records-side.png',
        'jam-sessions-side.png',
        'eazis-pulse-black-side.png',
      ],
      menu: false,
      saveImage: '',
      scrim: 'rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)',
      scrims: [
        'rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)',
        'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)',
        'rgba(244, 67, 54, .8), rgba(244, 67, 54, .8)',
      ],
      showImg: true,
    }),

    computed: {
      ...mapState(['barImage']),
      dark: {
        get () {
          return this.$store.state.darkMode
        },
        set (val) {
          this.$store.commit('SET_DARK_MODE', val)
        },
      },
      mini: {
        get () {
          return this.$store.state.mini
        },
        set (val) {
          this.$store.commit('SET_MINI', val)
        },
      },
    },

    watch: {
      color (val) {
        this.$vuetify.theme.themes[this.isDark ? 'dark' : 'light'].primary = val
      },
      showImg (val) {
        if (!val) {
          this.saveImage = this.barImage
          this.setBarImage('')
        } else if (this.saveImage) {
          this.setBarImage(this.saveImage)
          this.saveImage = ''
        } else {
          this.setBarImage(val)
        }
      },
      image (val) {
        this.setBarImage(val)
      },
      scrim (val) {
        this.$store.commit('SET_SCRIM', val)
      },
    },

    methods: {
      ...mapMutations({
        setBarImage: 'SET_BAR_IMAGE',
      }),
    },
  }
</script>

<style lang="sass">
  .v-settings
    .v-item-group > *
      cursor: pointer

    &__item
      border-width: 3px
      border-style: solid
      border-color: transparent !important

      &--active
        border-color: #70B615 !important
</style>
